export default __webpack_public_path__ + "static/media/M-Flow-master-logo.015d37d5.svg";